<div
  [@toggle]="state"
  (@toggle.start)="onAnimationEvent($event)"
  (@toggle.done)="onAnimationEvent($event)"
  [attr.class]="className"
>
  <div class="inside-border">
    <div
      *ngIf="currentNotificationStyle === NotificationStyle.Timeout"
      [style.width.%]="percentsOfProgress"
      class="progress-line"
    ></div>
  </div>
  <div
    [class.with-close-button-and-title]="
      (notificationRef?.config)!.showClose && data.title && !data.message && !data.actionButtonLabel
    "
    class="notification-content"
  >
    <div class="body">
      <ng-container portalHost></ng-container>
    </div>
    <div class="top-button-wrapper" *ngIf="data.topButtonLabel">
      <rt-button (click)="topButtonClick.emit()" variant="plain small">
        {{ data.topButtonLabel }}
      </rt-button>
    </div>
    <div class="close-button-wrapper" *ngIf="(notificationRef?.config)!.showClose">
      <div (click)="dismiss($event)" class="close-button">
        <rt-icon name="close"></rt-icon>
      </div>
    </div>
  </div>
</div>
